<mat-form-field appearance="fill">
  <mat-label>{{ label }}</mat-label>
  <button
    mat-button
    mat-icon-button
    matPrefix
    aria-label="Remove"
    [color]="color"
    (click)="incrementValue(-_step)"
    [disabled]="shouldDisableDecrement()">
    <mat-icon>remove</mat-icon>
  </button>
  <input
    matInput
    type="number"
    [formControl]="incrementFormControl"
    (focus)="color = 'primary'"
    (blur)="color = undefined" />
  <button
    mat-button
    mat-icon-button
    matSuffix
    aria-label="Add"
    [color]="color"
    (click)="incrementValue(_step)"
    [disabled]="shouldDisableIncrement()">
    <mat-icon>add</mat-icon>
  </button>
  <mat-hint>{{ hintBegin }}</mat-hint>
  <mat-hint align="end">{{ hintEnd }}</mat-hint>
</mat-form-field>
